import TextField from "@mui/material/TextField";
import { FormControl } from "@mui/material";
import { useEffect, useRef } from "react";

export default function BasicTextFields({
  value,
  maxLength,
  onChangeFun,
  type,
  placeholder,
  readOnly,
  required,
  name,
  disable,
  onBlurFunction,
  sx,
  onKeyPressFun,
  multiline,
  rows,
  maxRows,
  onFocusData,
  autoComplete = "off", // Set default value to "off"
  handlePaste,
  borderless = false,
  autoFocus = false,
  inputMode = "text",
  endAdornment,
}) {
  const inputRef = useRef(null);
  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);
  return (
    <FormControl fullWidth>
      <TextField
        inputRef={inputRef}
        // id="outlined-basic"
        sx={{
          fontFamily: "inherit",
          "& .MuiOutlinedInput-root": {
            "& fieldset": borderless ? { border: "none" } : {}, // Conditionally apply no border
            "&.Mui-focused fieldset": {
              borderColor: borderless
                ? "transparent"
                : "var(--qv-input-focus-border, var(--qv-bd-000000, black))",
              ...(borderless ? { border: "none" } : {}),
            },
          },
          ...sx,
        }}
        name={name}
        value={value}
        inputProps={{
          maxLength: maxLength,
          type: type,
          readOnly: readOnly,
          inputMode: inputMode,
        }}
        InputProps={{
          ...(name === "password"
            ? {
              sx: {
                "& .MuiInputBase-input": {
                  paddingRight: { xs: "46px" }, //  <-- added padding right
                },
              },
            }
            : {}),
          ...(endAdornment ? { endAdornment } : {}),
        }}
        onChange={onChangeFun}
        placeholder={placeholder}
        required={required}
        variant="outlined"
        size="small"
        disabled={disable}
        onBlur={onBlurFunction}
        onKeyPress={onKeyPressFun}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        onFocus={onFocusData}
        autoComplete={autoComplete}
        onPaste={handlePaste}
      // autoFocus={autoFocus}
      />
    </FormControl>
  );
}
